import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { classes } from '../../utils/Classes';
import { ProductContent } from '../product-content/ProductContent';
import { PRODUCT_TOUT_WRAPPER } from '~constants/DataTestIdAttributes';

export interface IProductToutProps {
    toutWidth?: number;
    toutHeight?: number;
    className?: string;
    nid: number;
}

const ProductToutWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    /*
        Fallback for touts with no content displayed
    */
    .elc-service-view-renderer {
        width: 100%;
        height: 100%;

        & > div:empty {
            height: 100%;
            background-color: #eee;
        }
    }
`;

export const ProductTout = observer(function ProductTout(props: IProductToutProps) {
    const productToutClassNames = classes('product-tout-wrapper');

    return (
        <ProductToutWrapper data-test-id={PRODUCT_TOUT_WRAPPER} className={productToutClassNames}>
            <ProductContent nid={props.nid} />
        </ProductToutWrapper>
    );
});
